import NeonText from './NeonText';

export default NeonText;
